import React from 'react';
import Header from "./Header";
import { Link } from 'react-router-dom';
import './CompanyPages.css';

export default function NotFound() {
  return (
    <div className="home">
      <Header />
      <main className="wc-info">
        <div className="wc-info-container">
          <p className="wc-info-eyebrow">404 / Not found</p>
          <h1>ページが見つかりません</h1>
          <p className="wc-info-lead">このページは削除されたか、URLが変更された可能性があります。<br />現在のサービスは、サービス一覧からご確認ください。</p>
          <div className="wc-info-company-links">
            <Link to="/service" className="wc-info-button">サービス一覧へ</Link>
            <Link to="/" className="wc-info-link">ホームへ戻る</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
